import React, { useEffect, useLayoutEffect, useState } from "react";
import cn from "classnames";
import style from "./style.module.scss";
import { Link, useNavigate } from "react-router-dom";
import ReloadIcon from "../icons/ReloadIcon";
import CustomButton from "../../custom/custom-button/CustomButton";
import PlusIcon from "../icons/PlusIcon";
import NotificationIconNew from "../icons/NotificationIconNew";
import { Notification } from "../../../services";
import UserProfileIcon from "../icons/UserProfileIcon";
import { useSelector } from "react-redux";
import { useAmplitude } from "../../../hooks/useAmplitude";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import { useTranslation } from "react-i18next";

const HeaderContentNew = ({
  title = "",
  practicalTitle = "",
  displayTitle = false,
  displayCreateBtn = false,
  displayPracticalBtn = false,
  displayReloadBtn = false,
  displayNotification = true,
  displayProfile = true,
  onPracticalBtnClick,
  onReload,
  }) => {
  const { t } = useTranslation();
  const { amplitude } = useAmplitude();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state);
  const [notificationsTotal, setNotificationsTotal] = useState(undefined);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [timeSinceUpdate, setTimeSinceUpdate] = useState(0);
  const [timerStopped, setTimerStopped] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    Notification.getQuantityNotifications({ isSeen: false })
      .then((res) => setNotificationsTotal(res.data.total))
      .catch((err) => requestErrorDisplay(err));
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      const timeElapsed = Math.floor((new Date() - lastUpdated) / 1000);
      if (timeElapsed >= 3600) {
        setTimerStopped(true);
        clearInterval(timer);
      } else {
        setTimeSinceUpdate(timeElapsed);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [lastUpdated]);

  const formatTime = (seconds) => {
    if (timerStopped) {
      return t('header.updatedTime.moreThanHour');
    }

    if (seconds < 60) {
      return t('header.updatedTime.secondsAgo', { count: seconds });
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return t('header.updatedTime.minutesAgo', { count: minutes });
    }
  };

  const handleReload = () => {
    setLastUpdated(new Date());
    setReloadKey((prevKey) => prevKey + 1);

    if (onReload) {
      onReload();
    }
  };

  return (
    <div className={cn(style.wrapper)}>
      {displayTitle && <div className={style.title}>{title}</div>}

      {displayReloadBtn && (
        <div className={cn(style.reload)}>
          <ReloadIcon className={cn(style.reload_btn)} key={reloadKey} onClick={handleReload} />
          <div className={cn("d-flex flex-column")}>
            <h1 className={style.title}>{title}</h1>
            <span className={style.updatedTime}>{t('header.updatedTime.updated')} {formatTime(timeSinceUpdate)} {t('header.updatedTime.ago')}</span>
          </div>
        </div>
      )}

      {displayCreateBtn && (
        <Link
          to="/orders/create"
          onClick={() => {
            amplitude.startCreatingOrder();
          }}
        >
          <CustomButton prefixStart={<PlusIcon fill="#fff" />} text={t('header.button.createNewOrder')} isMain />
        </Link>
      )}

      {practicalTitle && (
        <CustomButton
          prefixStart={<PlusIcon fill="#fff" />}
          text={practicalTitle}
          isMain
          onClick={onPracticalBtnClick}
        />
      )}

      {displayNotification && (
        <div
          className={cn("ms-auto", style.notification)}
          onClick={() => navigate("/notification")}
        >
          <NotificationIconNew />
          <div className={style.notification_count}>{notificationsTotal}</div>
        </div>
      )}

      <LanguageSelector />

      {displayProfile && (
        <div className={cn(style.profile)} onClick={() => navigate("/profile")}>
          <UserProfileIcon />
          <div className={style.profile_title}>
            <span>{user?.companyName}</span>
            <div className={style.profile_text}>{t('header.profile.bin')} {user?.bin}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderContentNew;
